// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"5b1834bb6701d10ec45d","97":"0cb1c0cfcf05ea4cc618","798":"47297169b29b51433627"}[chunkId] + ".js";
};